"use client";
import Typography from "@mui/material/Typography";
import type React from "react";

export interface VersionProps {
	version: string;
}

export function Version(props: VersionProps): React.ReactElement {
	const { version } = props;

	return <Typography variant="body1" color="grey">{`ver: ${version}`}</Typography>;
}
